export default function ArrowCta({ label, as: Tag = "span", className = "", ...props }) {
  return (
    <Tag className={`home-arrow-cta${className ? ` ${className}` : ""}`} {...props}>
      <span>{label}</span>
      <svg width="40" height="8" viewBox="0 0 40 8" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <line x1="0" y1="4" x2="38" y2="4" />
        <path d="M34 1 L39 4 L34 7" />
      </svg>
    </Tag>
  );
}
